import {
  GET_SPECIFICATION,
  GET_SPECIFICATION_SUCCESS,
  GET_SPECIFICATION_ERROR,
  GET_SPECIFICATION_LIST,
  GET_SPECIFICATION_LIST_SUCCESS,
  GET_SPECIFICATION_LIST_ERROR,
} from "./actionTypes"

export const getSpecification = data => ({
  type: GET_SPECIFICATION,
  payload: data,
})

export const getSpecificationSuccess = data => ({
  type: GET_SPECIFICATION_SUCCESS,
  payload: data,
})

export const getSpecificationError = data => ({
  type: GET_SPECIFICATION_ERROR,
  payload: data,
})

export const getSpecificationList = data => ({
  type: GET_SPECIFICATION_LIST,
  payload: data,
})

export const getSpecificationListSuccess = data => ({
  type: GET_SPECIFICATION_LIST_SUCCESS,
  payload: data,
})

export const getSpecificationListError = data => ({
  type: GET_SPECIFICATION_LIST_ERROR,
  payload: data,
})
